export default "__VITE_ASSET__BPJtOTtc__"